<template>
  <div class="min-h-view flex flex-col overflow-auto bg-white">
    <div v-if="noTickets" class="flex grow flex-col justify-center p-8 md:mx-auto md:max-w-(--breakpoint-xl)">
      <h2 class="text-center text-2xl">Billettene har ikke blitt sluppet for UL enda, men sjekk tilbake senere!</h2>
    </div>
    <div v-else class="my-5 flex w-full grow flex-row flex-wrap items-center justify-center overflow-auto py-6">
      <Ticket v-for="(ticket, idx) in tickets" :key="idx" :ticket="ticket" />
    </div>

    <PageFooter />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import PageFooter from '../components/PageFooter.vue'
import Ticket from '../components/Ticket.vue'
import { useTicketStore } from '../stores/ticket'

const ticketStore = useTicketStore()
const tickets = computed(() => ticketStore.tickets)
const noTickets = computed(() => tickets.value.length === 0)
</script>

<style lang="scss"></style>
